module.exports = __webpack_public_path__ + "static/img/logo.dcc476ea.png";